import {ITheme} from 'contexts/ThemeContext';
import {StyleSheet} from 'react-native';

export default (props: ITheme) =>
  StyleSheet.create({
    container: {
      justifyContent: 'center',
      alignItems: 'center',
      alignSelf: 'center',
      width: '90%',
      height: 52,
      borderRadius: 8,
      backgroundColor: props.colors.cornflowerBlue,
      marginBottom: 15,
    },
    textStyle: {
      fontSize: 19,
      lineHeight: 31,
      color: props.colors.white,
      ...props.typography.mulishBold,
    },
  });
